module.exports = __webpack_public_path__ + "img/bg_parallax.666da9d8.jpg";